import * as React from 'react';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Select from 'react-select';
import { Button, Col, Form, Row, Container } from 'react-bootstrap';
import {
    deleteVideoCampaign,
    listVideoCampaignDetails,
    updateVideoCampaign,
} from '../actions/videoCampaignActions';
import { listTags } from '../actions/tagActions';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {
    VIDEO_CAMPAIGN_UPDATE_DETAILS_RESET,
    VIDEO_CAMPAIGN_DELETE_RESET, VIDEO_CAMPAIGN_UPDATE_SUCCESS,
} from '../constants/videoCampaignConstants';
import { listVideoPlayers } from '../actions/videoPlayerActions';
import { listMedia } from '../actions/mediaActions';
import {logout} from "../actions/userActions";
import ThreeColumnRow from "../components/ThreeColumnRow";
import {MultiSelect} from "../components/MultiSelect";
import CreatableSelect from "react-select/creatable";

const VideoCampaignScreen = ({ match, history, language, t }) => {
    const dispatch = useDispatch();
    const videoCampaignId = match.params.id;
    const tagList = useSelector((state) => state.tagList);
    const {
        loading: tagsLoading,
        error: tagsError,
        tags: userTags,
        success: userTagSuccess,
    } = tagList;
    const [tags, setTags] = useState([]);
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const videoCampaignDetails = useSelector((state) => state.videoCampaignDetails);
    const { loading, videoCampaign, error } = videoCampaignDetails;
    const videoCampaignUpdate = useSelector((state) => state.videoCampaignUpdate);
    const { success } = videoCampaignUpdate;
    const videoCampaignDelete = useSelector((state) => state.videoCampaignDelete);
    const { success: deleteSuccess } = videoCampaignDelete;

    const [name, setName] = useState('');
    const [videoCampaignNameError, setCampaignNameError] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const [validFrom, setValidFrom] = useState('');
    const [validTo, setValidTo] = useState('');
    const [validationError, setValidationError] = useState(null);
    const [isEnabled, setIsEnabled] = useState(true);
    const [isExclusive, setIsExclusive] = useState(false);

    const videos = useSelector((state) => state.videoList);
    const {
        loading: videosLoading,
        videoList,
        error: videoError,
    } = videos;
    const [videoOptions, setVideoOptions] = useState();
    const [selectedVideos, setSelectedVideos] = useState([]);
    const [description, setDescription] = useState('');
    const [videoPlayerTagsOptions, setVideoPlayerTagsOptions] = useState([]);
    const [selectedVideoPlayerTags, setSelectedVideoPlayerTags] = useState([]);
    const [selectedVideoTags, setSelectedVideoTags] = useState([]);
    const [videoTagsOptions, setVideoTagsOptions] = useState([]);

    const videoPlayersList = useSelector((state) => state.videoPlayerList);
    const {
        loading: videoPlayersLoading,
        videoPlayers: videoPlayerList,
        error: videoPlayersError,
    } = videoPlayersList;
    const [videoPlayerOptions, setVideoPlayerOptions] = useState([]);
    const [selectedVideoPlayers, setSelectedVideoPlayers] = useState([]);

    const onSelectedVideoTagsChange = (videoTagsFromSelect) => {
        setSelectedVideoTags(videoTagsFromSelect);
        let tagNames = videoTagsFromSelect.map((e) => e.name);

        //console.log(tagNames);
        let videosSelected = selectedVideos.slice();

        if(tagNames.length > 0) {
            videoOptions.forEach((element) => {
                if (element.tags.filter(e => tagNames.includes(e.name)).length > 0 && videosSelected.filter(e => e._id === element._id).length === 0) {
                    videosSelected.push(element);
                }
                else if(element.tags.filter(e => tagNames.includes(e.name)).length === 0 && videosSelected.filter(e => e._id === element._id).length !== 0){
                    let idx;
                    let exists = videosSelected.some((item, index) => {
                        idx = index;
                        return item._id === element._id;
                    });
                    if(exists){
                        videosSelected.splice(idx, 1);
                    }
                }
            });

            setSelectedVideos(videosSelected);
        }
        else {
            setSelectedVideos([]);
        }

    };

    const onSelectedVideoPlayerTagsChange = (videoPlayerTagsFromSelect) => {
        setSelectedVideoPlayerTags(videoPlayerTagsFromSelect);
        let tagNames = videoPlayerTagsFromSelect.map((e) => e.name);
        //console.log(tagNames);
        let videoPlayersSelected = selectedVideoPlayers.slice();

        if(tagNames.length > 0) {
            videoPlayerOptions.forEach((element) => {
                if (element.tags.filter(e => tagNames.includes(e.name)).length > 0 && videoPlayersSelected.filter(e => e.folder === element.folder).length === 0) {
                    videoPlayersSelected.push(element);
                }
                else if(element.tags.filter(e => tagNames.includes(e.name)).length === 0 && videoPlayersSelected.filter(e => e.folder === element.folder).length !== 0){
                    let idx;
                    let exists = videoPlayersSelected.some((item, index) => {
                        idx = index;
                        return item.folder === element.folder;
                    });
                    if(exists){
                        videoPlayersSelected.splice(idx, 1);
                    }
                    //videoPlayersSelected.splice(videoPlayersSelected.findIndex(element), 1);
                }
            });

            setSelectedVideoPlayers(videoPlayersSelected);
        }
        else {
            console.log('empty tag names');
            setSelectedVideoPlayers([]);
        }

        //console.log(Array.from(videoPlayersSelected));
    };

    const onSelectedVideosChange = (videosFromSelect) => {
        setSelectedVideos(videosFromSelect);
    };

    const onSelectedVideoPlayersChange = (videoPlayersFromSelect) => {
        setSelectedVideoPlayers(videoPlayersFromSelect);
    };

    useEffect(() => {
        dispatch({type: VIDEO_CAMPAIGN_UPDATE_DETAILS_RESET});
    }, []);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        if (
            !videoCampaign ||
            !videoCampaign.name ||
            success ||
            videoCampaign._id !== videoCampaignId
        ) {
            dispatch({ type: VIDEO_CAMPAIGN_UPDATE_DETAILS_RESET });
            dispatch(listVideoCampaignDetails(match.params.id));
        } else {
            if (videoCampaign.videos) {
                setSelectedVideos(() =>
                    videoCampaign.videos.map((video) => {
                        //console.log(video.name);
                        video.label = video.name;
                        video.value = video._id;
                        return video;
                    })
                );
            }

            if (videoCampaign.videoPlayers) {
                setSelectedVideoPlayers(() =>
                    videoCampaign.videoPlayers.map((videoPlayer) => {
                        videoPlayer.label = videoPlayer.name;
                        videoPlayer.value = videoPlayer._id;
                        return videoPlayer;
                    })
                );
            }
            setValidTo(videoCampaign.validTo);
            setValidFrom(videoCampaign.validFrom);
            setDescription(videoCampaign.description);
            setName(videoCampaign.name);

            if(videoCampaign.tags){
                setTags(() =>
                    videoCampaign.tags.map((tgs) => {
                        tgs.label = tgs.name;
                        tgs.value = tgs._id;
                        return tgs;
                    })
                );
            }
            //setTags(videoCampaign.tags);
            setIsEnabled(videoCampaign.isEnabled);
            setIsExclusive(videoCampaign.isExclusive);
        }
    }, [dispatch, match, videoCampaign, videoCampaignId]);

    useEffect(() => {
        if (!userTagSuccess || success) {
            dispatch(listTags());
        } else {
            setSuggestions(() =>
                userTags.map((tgs) => {
                    tgs.label = tgs.name;
                    tgs.value = tgs._id;
                    return tgs;
                })
            );
            //setSuggestions(userTags);
        }
    }, [userTagSuccess, dispatch]);

    const deleteVideoCampaignHandle = async () => {
        dispatch(deleteVideoCampaign(videoCampaign._id));
    };

    useEffect(() => {
        dispatch(listMedia('videos'));
        dispatch(listVideoPlayers());
    }, [dispatch]);

    useEffect(() => {
        if (deleteSuccess) {
            history.push('/video_campaigns');
            dispatch({ type: VIDEO_CAMPAIGN_DELETE_RESET });
        } else {
            dispatch({ type: VIDEO_CAMPAIGN_DELETE_RESET });
        }
    }, [deleteSuccess, dispatch, history]);

    useEffect(() => {
        if (videoPlayerList) {
            const moddedList = videoPlayerList.map((element) => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setVideoPlayerOptions(moddedList);

            const moddedTagList = [];
            videoPlayerList.forEach((element) => {
                let insideTags = element.tags;
                //console.log(insideTags);
                insideTags.forEach(tag => {
                    tag.label = tag.name;
                    tag.value = tag._id;
                    if(!moddedTagList.some((item,index) => {
                        return item.name === tag.name;
                    })) {
                        moddedTagList.push(tag);
                    }
                });
            });
            setVideoPlayerTagsOptions(moddedTagList);
        }
    }, [videoPlayerList]);

    useEffect(() => {
        if (!videosLoading && videoList != null) {
            let idk = videoList.map((video) => {
                video.label = video.name;
                video.value = video._id;
                return video;
            });
            setVideoOptions(idk);

            const moddedTagList = [];
            idk.forEach((element) => {
                let insideTags = element.tags;
                //console.log(insideTags);
                insideTags.forEach(tag => {
                    tag.label = tag.name;
                    tag.value = tag._id;
                    if(!moddedTagList.some((item,index) => {
                        return item.name === tag.name;
                    })) {
                        moddedTagList.push(tag);
                    }
                });
            });
            setVideoTagsOptions(moddedTagList);
        }
    }, [videosLoading, videoList]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) {
            return;
        }
        if(videoCampaignNameError !== ''){
            return;
        }
        if (e.key === 'Enter') {
            return;
        }

        let label,value

        let videos = [];
        if (selectedVideos) {
            videos = selectedVideos.map(element => {
                let {label,value, ...rest} = element;
                return rest;
            });
        }

        let videoPlayers = [];
        if (selectedVideoPlayers) {
            videoPlayers = selectedVideoPlayers.map(element => {
                let {label,value, ...rest} = element;
                return rest;
            });
        }

        const videoCampaign = {
            videos: videos,
            validFrom: validFrom,
            validTo: validTo,
            description: description,
            name: name,
            tags: tags,
            isEnabled: isEnabled,
            isExclusive: isExclusive,
            videoPlayers: videoPlayers,
        };
        console.log(videoCampaign);
        dispatch(updateVideoCampaign(videoCampaignId, videoCampaign));
    };

    // TODO: remove px styles
    const validate = () => {
        setValidationError(null);
        let errors = '';
        /*if (!periodicActive && !hasSpecificTimes) {
            errors += t('video_videoCampaign_validation_error_periodic_or_specific');
        }*/
        /*if (hasSpecificTimes && specificTimes.length === 0) {
            errors += t('video_videoCampaign_validation_error_missing_specific');
        }*/
        if (
            selectedVideos.length === 0
        ) {
            errors += t('video_video_campaign_validation_error_no_real_content');
        }
        if (validFrom === '' || validTo === '') {
            errors += t('video_video_campaign_validation_error_missing_period');
        }

        if (errors !== '') {
            setValidationError(errors);
            return false;
        } else {
            return true;
        }
    };

    return (
        <>
            <Container>
                {success && (
                    <Message variant='success'>{t('video_campaign_refreshed')}</Message>
                )}

                <ThreeColumnRow firstColumn={<Link to='/video_campaigns' className='btn btn-info m-0 p-2'>
                    {t('button_back')}
                </Link>} secondColumn={t('video_campaign_data')} thirdColumn={<div
                    className='btn btn-danger m-0 p-2'
                    onClick={() => deleteVideoCampaignHandle()}
                >
                    {t('button_delete')}
                </div>}/>

                <Form autoComplete='off' onSubmit={handleSubmit}>
                    <Row>
                        <Col lg>
                            <Form.Group controlId='video_campaign_name'>
                                <Form.Label>{t('video_campaign_name')}</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={(t('video_campaign_name'))}
                                    required
                                    value={name}
                                    onChange={(event) => {
                                        if(event.target.value.includes(',')){
                                            setCampaignNameError(t('video_campaign_name_error'));
                                        }
                                        else {
                                            setCampaignNameError('');
                                        }
                                        setName(event.target.value);
                                    }}
                                    isInvalid={name.includes(',')}
                                />
                                <Form.Control.Feedback type='invalid'>{videoCampaignNameError}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>{t('video_campaign_period')}</Form.Label>
                                <Form.Row className='ml-0 mr-0 mt-2'>
                                    <input
                                        type='date'
                                        onChange={(e) => {
                                            setValidFrom(e.target.value);
                                        }}
                                        value={validFrom}
                                    />
                                    <label className='ml-2 mt-auto mr-auto mb-auto'>
                                        -
                                    </label>
                                    <Col>
                                        <input
                                            type='date'
                                            className=''
                                            onChange={(e) => {
                                                setValidTo(e.target.value);
                                            }}
                                            value={validTo}
                                        />
                                    </Col>
                                </Form.Row>
                            </Form.Group>
                            <Form.Group controlId='videoCampaignDescription'>
                                <Form.Label>{t('video_campaign_description')}</Form.Label>
                                <Form.Control
                                    type='text'
                                    placeholder={t('video_campaign_description_description')}
                                    value={description ? description : ''}
                                    onChange={(event) => {
                                        setDescription(event.target.value);
                                    }}
                                />
                            </Form.Group>
                            {tagsLoading ? (
                                <Loader />
                            ) : (
                                <Form.Group controlId='tags'>
                                    <Form.Label>{t('video_campaign_tags')}</Form.Label>
                                    <CreatableSelect
                                        isMulti
                                        isSearchable
                                        isClearable
                                        formatCreateLabel= {(inputValue) => `${t('create_tag')}: "${inputValue}"`}
                                        onChange={(newTag) => {
                                            const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                            if(temporaryTag !== null && temporaryTag !== undefined){
                                                newTag = temporaryTag;
                                            }
                                            //console.log(newTag);
                                            setTags(newTag);
                                        }}
                                        onCreateOption={(newTag) => {
                                            const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                            if(temporaryTag !== null && temporaryTag !== undefined){
                                                newTag = temporaryTag;
                                            }
                                            else {
                                                newTag = {
                                                    id: undefined,
                                                    label: newTag,
                                                    value: newTag,
                                                    name: newTag
                                                }
                                            }
                                            //console.log(newTag);
                                            setTags([...tags, newTag]);
                                        }}
                                        options={suggestions}
                                        value={tags}
                                        placeholder={t('video_campaign_tags_description')}
                                        className='react-select-container'
                                        classNamePrefix='react-select'
                                        styles={{
                                            // Fixes the overlapping problem of the component
                                            menu: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                    />
                                    {/*<ReactTags
                                        allowNew={true}
                                        placeholderText={t('video_videoCampaign_tags_description')}
                                        allowBackspace={false}
                                        onDelete={(idx) => {
                                            const newTags = tags.slice(0);
                                            newTags.splice(idx, 1);
                                            setTags(newTags);
                                        }}
                                        onAddition={(newTag) => {
                                            console.log(newTag);
                                            const temporaryTag = suggestions.find(tag => tag.name === newTag.name);

                                            if(temporaryTag !== null && temporaryTag !== undefined){
                                                newTag = temporaryTag;
                                            }
                                            //console.log(newTag);
                                            setTags([...tags, newTag]);
                                        }}
                                        suggestions={suggestions}
                                        tags={tags}
                                    />*/}
                                </Form.Group>
                            )}
                            <Form.Group controlId='videoCampaignIsExclusive'>
                                <Form.Label>{t('video_campaign_isExclusive')}</Form.Label>

                                <div className="custom-control custom-switch custom-switch-md">
                                    <input checked={isExclusive} type="checkbox" className="custom-control-input" id="customSwitch8" onChange={(event) => {
                                        setIsExclusive(event.target.checked);
                                    }}/>
                                    <label className="custom-control-label" htmlFor="customSwitch8">{isExclusive ? t('campaign_exclusive') : t('campaign_not_exclusive')}</label>
                                </div>
                            </Form.Group>
                            {validationError ? (
                                <Message variant='danger'>
                                    {validationError}
                                </Message>
                            ) : null}
                            {loading ? <Loader /> : null}
                            {error ? (
                                <Message variant='danger'>{error}</Message>
                            ) : null}
                        </Col>
                        <Col lg>
                            <Form.Group controlId='videosByTagsName'>
                                <Form.Label>{t('video_campaign_select_videos_by_tags')}</Form.Label>
                                <MultiSelect
                                    options={videoTagsOptions}
                                    value={selectedVideoTags}
                                    onChange={onSelectedVideoTagsChange}
                                    placeholder={t('video_campaign_select_videos_by_tags')}
                                />
                            </Form.Group>
                            <Form.Group controlId='videos'>
                                <Form.Label>{t('video_campaign_videos')}</Form.Label>
                                <MultiSelect
                                    options={videoOptions}
                                    onChange={onSelectedVideosChange}
                                    placeholder={t('video_campaign_videos_description')}
                                    value={selectedVideos}
                                />
                            </Form.Group>
                            <Form.Group controlId='videoPlayersByTagsName'>
                                <Form.Label>{t('video_campaign_select_video_players_by_tags')}</Form.Label>
                                <MultiSelect
                                    options={videoPlayerTagsOptions}
                                    value={selectedVideoPlayerTags}
                                    onChange={onSelectedVideoPlayerTagsChange}
                                    placeholder={t('video_campaign_select_video_players_by_tags')}
                                />
                            </Form.Group>
                            <Form.Group controlId='videoPlayersName'>
                                <Form.Label>{t('video_campaign_video_players')}</Form.Label>
                                <MultiSelect
                                    options={videoPlayerOptions}
                                    value={selectedVideoPlayers}
                                    onChange={onSelectedVideoPlayersChange}
                                    placeholder={t('video_campaign_video_players_description')}
                                />
                            </Form.Group>
                            <Form.Group controlId='videoCampaignIsEnabled'>
                                <Form.Label>{t('video_campaign_isEnabled')}</Form.Label>

                                <div className="custom-control custom-switch custom-switch-md">
                                    <input checked={isEnabled} type="checkbox" className="custom-control-input" id="customSwitch7" onChange={(event) => {
                                        setIsEnabled(event.target.checked);
                                    }}/>
                                    <label className="custom-control-label" htmlFor="customSwitch7">{isEnabled ? t('campaign_active') : t('campaign_inactive')}</label>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Button
                        type='submit'
                        variant='success'
                        className='d-block mx-auto mt-2'
                    >
                        {t('button_save')}
                    </Button>
                </Form>
            </Container>
        </>
    );
};

export default VideoCampaignScreen;
